import React, { useState, useContext, useEffect } from "react";
import CrossCloseButton from "./parts/CrossCloseButton";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closePopup } from "../redux/actions/modal";
import { PoppupError, PoppupSucces } from "../components/IconsSVG";
import WBNB from "../assets/images/wbnb.png";
import BUSD from "../assets/images/busd.png";
import RASKO from "../assets/images/rasko.png";
import CohortLoading from "../components/IconsSVG";

import { Web3Context } from "../contexts/Web3Context";

import {
  getCohortContract,
  isApprovedForAmount,
  approveErc20,
  ethToWei,
} from "../apis/blockchain";
import * as cohortApi from "../apis/cohort";
import { rAskoAddress, rAskoCohortAddress } from "../constants/addresses";
import { roundString } from "../apis/utils";

export default function () {
  const [status, setStatus] = useState("success");
  const [text, setText] = useState("Your transaction successfully");
  const dispatch = useDispatch();
  const rasko = useSelector((state) => state.modal.data.rasko);
  const busd = useSelector((state) => state.modal.data.busd);
  const wbnb = useSelector((state) => state.modal.data.wbnb);
  const amount = useSelector((state) => state.modal.data.amount);
  const [method, setMethod] = useState(
    useSelector((state) => state.modal.data.method)
  );
  const [loading, setLoading] = useState(false);
  let history = useHistory();

  const web3Context = useContext(Web3Context);

  const handleApprove = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await approveErc20(
        web3Context.web3.web3Provider,
        rAskoAddress,
        rAskoCohortAddress
      );
      alert("Approved!");
      setMethod("deposit");
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const handleDeposit = async (e) => {
    e.preventDefault();
    if (isNaN(amount) || amount == 0) {
      alert("Please enter an amount greater than 0 to deposit");
      return;
    }
    try {
      // check for approval again
      const approved = await isApprovedForAmount(
        web3Context.web3.web3Provider,
        rAskoAddress,
        web3Context.currentAccountAddress,
        rAskoCohortAddress,
        amount
      );

      if (!approved) {
        await handleApprove();
      }
      setLoading(true);

      const depositWei = ethToWei(amount);
      await cohortApi.deposit(
        await getCohortContract(web3Context.web3.web3Provider),
        depositWei
      );
      alert(`Deposited ${roundString(amount, 4)}`);
      setLoading(false);
      window.location.reload();
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };


  return (
    <div
      className={
        status === "error"
          ? "modal modal_w550 cohort_popup error"
          : "modal modal_w550 cohort_popup"
      }
      style={{ padding: "15px" }}
    >
      <div className="modal-supply__close">
        <CrossCloseButton className="custom-cross-btn_black" />
      </div>
      <div className="cohort_modal_main">
        <h4>rASKO APR UP TO</h4>
        <div className="cohort_modal_main_block">
          <span>
            <img src={RASKO} />
            rASKO
          </span>{" "}
          <strong>{rasko}%</strong>
          {/* <span>APR</span> */}
        </div>
        <h4>Current rate of rewards per 1000 rASKO</h4>
        <div className="cohort_modal_main_row">
          <div className="cohort_modal_main_block">
            <span>
              <img src={WBNB} />
              WBNB
            </span>{" "}
            <strong>{wbnb}</strong>
            {/* <span>APR</span> */}
          </div>
          <div className="cohort_modal_main_block">
            <span>
              <img src={BUSD} />
              BUSD
            </span>{" "}
            <strong>{busd}</strong>
            {/* <span>APR</span> */}
          </div>
        </div>
        <div className="cohort_popup_description">
          <p>
            The rewards per 1000 rAsko is dependent on the current speed of
            distribution of each token, and dependent on your share of tokens in
            the staking pool.
          </p>
          <p>
            As users deposit/withdraw staked tokens, the rates for BUSD/WBNB
            would fluctuate accordingly.
          </p>
          <p>
            *your actual rate of return may be less than or greater than the
            estimated rate at this time.
          </p>
          {method === "deposit" ? (
            <p>Please confirm your deposit amount below</p>
          ) : (
            <p>Please first approve rAsko to be used by the platform</p>
          )}
          <button
            className="farm-item__btn"
            onClick={method === "deposit" ? handleDeposit : handleApprove}
          >
            {method === "deposit" ? (
              <>Deposit {roundString(amount, 4)} rASKO</>
            ) : (
              <>Approve</>
            )}
            {loading ? <CohortLoading /> : null}
          </button>
        </div>
      </div>
    </div>
  );
}
